import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import { enhanceWithTrackable } from '@origin-digital/style-guide';
import { ChevronLeftIcon, ClearIcon } from '@origin-digital/icon';
import { LG } from '@origin-digital/helper';
var BackButtonContainer = styled.div.withConfig({
  displayName: "MobileNavButton__BackButtonContainer",
  componentId: "ek8mhy-0"
})(["margin-left:-4px;"]);

var getButton = function getButton(type) {
  switch (type) {
    case 'back':
      return React.createElement(BackButtonContainer, null, React.createElement(ChevronLeftIcon, {
        size: 32,
        color: "red"
      }));

    case 'close':
      return React.createElement(ClearIcon, {
        color: "red"
      });

    default:
      var _exhaustiveCheck = type;
  }
};

var MobileNavButtonButton = styled.button.withConfig({
  displayName: "MobileNavButton__MobileNavButtonButton",
  componentId: "ek8mhy-1"
})(["box-sizing:border-box;display:inline-flex;align-items:center;white-space:nowrap;justify-content:center;outline:none;width:44px;position:absolute;left:0;border:0;padding:0 6px;border:0;background-color:transparent;cursor:pointer;", ""], LG(_templateObject()));

var MyMobileNavButton = function MyMobileNavButton(_ref) {
  var type = _ref.type,
      onClick = _ref.onClick;
  return !type || type === 'none' ? null : React.createElement(MobileNavButtonButton, {
    onClick: onClick,
    "data-id": "action-bar:mobile-nav-button",
    "aria-label": type,
    type: "button"
  }, getButton(type));
};

export var MobileNavButton = enhanceWithTrackable(MyMobileNavButton);